//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import "./ChatGPTpage.less"
import Chatframe from "../../myComponents/Chatframe/Chatframe.vue";
import ChatInput from '../../myComponents/ChatInput/ChatInput.vue';
import { CHAT_ROLE, CHAT_TYPE } from "../../myComponents/Chatframe";
import { getChatStat,chatServiceStart  } from "../../api/api";
import { CHAT_EVNET, CHAT_MSG_TYPE } from "../../S51WebGLSDK/define";
import AwaitReplyModel from "../../myComponents/awaitReplyModel/awaitReplyModel.vue"
import {
  utils
} from '../../S51WebGLSDK/utils/utils';
import PaymentModel from "../../myComponents/PaymentModel/PaymentModel.vue";
import PageVisible from "../../myComponents/PageVisible/PageVisible.vue";
export default {
name: 'ChatGPTpage',
  components: {
    Chatframe,
    ChatInput,
    AwaitReplyModel,
    PaymentModel,
    PageVisible
},
  props: {},
  data() {
    return {
      voiceContentList: [],
      packUnfoldBlo:false,
      isLoading: false,
      curAppID:'',
      chatType:0,
      awaitReply:false,
      purchaseModelIsopen:false,
      isHasConsume:false
    }
  },
  computed: {},
  watch: {
   voiceContentList(value) {
      let getlos = localStorage.getItem("packUnfoldBlo_GPT");

      console.log('%c⧭', 'color: #514080', "xixixiixi")
      if (getlos == null || getlos == undefined || getlos == "") {
        console.log('%c⧭', 'color: #73998c', "SADFSAFAS")
        localStorage.setItem("packUnfoldBlo_GPT", true);
        this.packUnfoldBlo = true;
      }
      if(value.length <=0)
      {
        this.packUnfoldBlo = false;
         localStorage.removeItem("packUnfoldBlo_GPT");
      }
      console.log("%c⧭", "color: #e57373", value);
    },
  },
  mounted() {
    document.title='智能AI聊天机器人'
  },
  destroyed()
  {
  },
  created() {
    localStorage.removeItem("packUnfoldBlo_GPT");
    getChatStat().then(res=>{
      this.curAppID = res.data.app_info.app_id;
      chatServiceStart(res.data.app_info.app_id).then(prce=>{

        console.log('%c⧭', 'color: #ace2e6', prce)
      })
    })
    let param = utils.getUrlParams(window.location.href)
    this.chatType = param.type == 'GPT' ? 3 : 0
    console.log('%c⧭', 'color: #86bf60', this.chatType)
  },
  methods: {
    //默认文案发送
    onSendText(e)
    {
      
      console.log('%c⧭', 'color: #eeff00', this.purchaseModelIsopen)
      this.sendWord2Human(e)
    },
    onInputWordSend(message){
      console.log('send message',message)
      if(this.isLoading){
        return
      }
      if (!message || message.length == 0) {
        return;
      }
      this.sendWord2Human(message)
    },
    onInputStartRecordAudio(){
      console.log('开始录音')
      S51WebGLSDK.stopNowVoice();
    },
    onInputEndRecordAudio(data){
      console.log('结束录音',data)
      this.awaitReply=true;
      this.$refs.myChatFrame.chat(CHAT_TYPE.VOICE,data).then(
        ()=>{
          this.isHasConsume=true
        },//成功
        (err)=>{console.error(err)}
      ).finally(()=>{ this.awaitReply=false;})
   
    },
    sendWord2Human(myChatMessage){
      this.awaitReply=true;
      this.$refs.myChatFrame.chat(CHAT_TYPE.TEXT,myChatMessage).then(
        ()=>{
          this.isHasConsume=true
        },//成功
        (err)=>{ console.error(err)}
      ).finally(()=>{ this.awaitReply=false;})
    },
    
    informImmediatelyPurchase(e){
      if(e){//充值成功
        this.purchaseModelIsopen=false
        this.$vux.toast.show({
            type: "text",
            text: "充值成功",
        })
        
      }
    },
    onOpenChargeModel(){
      this.purchaseModelIsopen=true;
      console.log('-----open charge')
    },
    onChatLeftNotEnough(){
  
      this.purchaseModelIsopen=true;
      this.awaitReply=false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ChatGPTpage/ChatGPTpage.vue